<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--customisation">
            <h1 class="text-center pad-top--xl z-up text-white text-caps">
                Customisation
            </h1>
            <h5 class="text-center text-white pad-bottom--xl text-caps">
                <router-link to="/contact-us" class="text-white">
                    Get in touch now for a free quote
                </router-link>
            </h5>
        </div>
        <div class="grid-x grid-padding-x bg--lilac" style="margin-top:-10px">
            <div class="cell small-12 medium-6 medium-offset-3 pad-top--xxl">
                <router-link to="/screen-printing" class="customisation-link screenprint">Screenprint</router-link>
                <router-link to="/embroidery-service" class="customisation-link embroidery">Embroidery</router-link>
                <router-link to="/direct-to-garment-printing" class="customisation-link dtg">Direct to garment</router-link>
                <router-link to="/garment-finishing-relabeling" class="customisation-link finishing">Garment finishing</router-link>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Customisation',
    metaInfo() {
        return {
            title: 'Customisation',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Customisation' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/customisation' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Customisation.vue